
const digest = '4ea3865f59cf671c9d3b2c3fc4355af94149207819ce22ef9eeadbd4e4f05963';
const classes = {"wrapper":"_wrapper_7o0he_1","item":"_item_7o0he_6","title":"_title_7o0he_14","description":"_description_7o0he_19"};
const css = `._wrapper_7o0he_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_7o0he_1 ._item_7o0he_6 {
  border: 1px solid #d1d4da;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  padding: 24px;
  justify-content: space-between;
}
._wrapper_7o0he_1 ._item_7o0he_6 ._title_7o0he_14 {
  color: #1665d8;
  font-size: 16px;
  font-weight: 600;
}
._wrapper_7o0he_1 ._item_7o0he_6 ._description_7o0he_19 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  